import { ConfigProvider } from "antd";
import { CustomThemeProvider } from "customHooks/ThemeContext";
import MainScreenLoader from "loaders/MainScreenLoader";
import React, { lazy } from "react";
import 'react-loading-skeleton/dist/skeleton.css';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.min.css';
import { ThemeProvider } from "styled-components";

const AppRoutes = lazy(() => import('routes/Routes'));


function App() {
  return (
    <React.Suspense
      fallback={<MainScreenLoader />}
    >
      <CustomThemeProvider>
        <ThemeProvider
          theme={
            {
              primary: "#B01E1E"
            }
          }>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: "#B01E1E",
                colorPrimaryActive: "#B01E1E",
              },
              components: {
                Timeline: {
                  tailColor: '#D8D8EA'
                },
                Segmented: {
                  itemSelectedBg: "#B01E1E",
                  itemSelectedColor: '#fff',
                  // trackBg: '#0000'
                }
              }
            }}
          >
            <AppRoutes />
            <ToastContainer />
          </ConfigProvider>
        </ThemeProvider>
      </CustomThemeProvider>
    </React.Suspense>
  );
}

export default App;